



































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { PPE_STATUS } from "@/services/Enums";
import { PlanFinal } from "@/entity/Ppe/PlanFinal";
import { General } from "@/services/General";
import { ClaimEnum } from "@/services/ClaimEnum";

@Component({
    components: {
    }
})
export default class PlanEvaluationForm extends Vue {
    @Prop({ type: Boolean, required: true })
    planFinalEditable;
    @Prop({ required: true })
    planTarget;
    @Prop({ required: true })
    symbolProp;
    @Prop({ required: true })
    kSymbolProp;
    @Prop({ required: true })
    planFinalProp;
    @Prop({ type: Boolean, required: true })
    isSaveClicked;
    @Prop({ type: Number, required: true })
    planStatus;
    @Prop({ type: Number, required: false })
    planTargetTotalVolumeYearBeforeProp;

    planFinal: PlanFinal = new PlanFinal();
    evaluationMarkOptions: Array<number> = [5,4,3,2,1];
    planTargetTotalVolumeYearBefore: number = 0;
    symbolUnitOfMeasurementPlan : string = "";
    kSymbolUnitOfMeasurementPlan : string = "";

    entityMounted: boolean = false;
    confirmIncidencesRecalc: boolean = true;

    extraVolumePromo: number = null;
    extraGPPromo: number = null;
    valueROI: number = null;

    extraVolumePromoFinal: number = null;
    extraGPPromoFinal: number = null;
    valueROIFinal: number = null;

    recalculateExtraVolumePromo: boolean = false;
    recalculateExtraGPPromo: boolean = false;
    recalculateROI: boolean = false;
    recalculateIncidence: boolean = false;

    isAdminPpe: boolean = false;

    get borderColorExtraVolumePromo(){
        return this.recalculateExtraVolumePromo ? 'border-color: #4285f4;' : '';
    }

    get borderColorExtraGPPromo(){
        return this.recalculateExtraGPPromo ? 'border-color: #4285f4;' : '';
    }

    get borderColorROI(){
        return this.recalculateROI ? 'border-color: #4285f4;' : '';
    }

    get borderColorIncidence(){
        return this.recalculateIncidence ? 'border-color: #4285f4;' : '';
    }


    async mounted() {
        this.isAdminPpe = this.checkPpeAdminClaim();
        this.planFinal = this.planFinalProp;
        this.planTargetTotalVolumeYearBefore = this.planTargetTotalVolumeYearBeforeProp;
        this.entityMounted = true;
        this.symbolUnitOfMeasurementPlan = this.symbolProp;
        this.kSymbolUnitOfMeasurementPlan = this.kSymbolProp;
        this.calculateExtraVolumePromo(false);
        this.calculateExtraVolumePromo(true);
    }

    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    calculateExtraVolumePromo(isPlanFinal:boolean){
        let plan = isPlanFinal ? this.planFinal : this.planTarget;
        if(this.isNotNullOrNaN(plan.totalVolumeTons) && this.isNotNullOrNaN(this.planTarget.lastYearVolumeBaseLine )){
                let extraVolumePromo = plan.totalVolumeTons - this.planTarget.lastYearVolumeBaseLine;  
                if(isPlanFinal){
                    this.recalculateExtraVolumePromo = true;
                    this.extraVolumePromoFinal = extraVolumePromo;
                    setTimeout(() => this.recalculateExtraVolumePromo = false , 2000); 
                }else{
                    this.extraVolumePromo = extraVolumePromo;
                }
                this.calculateExtraGPPromo(isPlanFinal);
            }else{
                if(isPlanFinal){
                    this.extraGPPromoFinal = null;
                    this.extraVolumePromoFinal = null;
                    this.valueROIFinal = null; 
                }else{
                    this.extraGPPromo = null;
                    this.extraVolumePromo = null;
                    this.valueROI = null; 
                }
            }
    }
    
    calculateExtraGPPromo(isPlanFinal:boolean){
        let plan = isPlanFinal ? this.planFinal : this.planTarget;
        let extraVolumePromo = isPlanFinal ? this.extraVolumePromoFinal : this.extraVolumePromo
            if(this.isNotNullOrNaN(plan.grossProfit) && this.isNotNullOrNaN(extraVolumePromo) && this.isNotNullOrNaN(plan.costPPE) ){
                let extraGPPromo = Number((((plan.grossProfit * 1000) * extraVolumePromo) - plan.costPPE).toFixed(2));
                if(isPlanFinal){
                    this.recalculateExtraGPPromo = true;
                    this.extraGPPromoFinal = extraGPPromo;
                    setTimeout(() => this.recalculateExtraGPPromo = false , 2000); 
                }else{
                    this.extraGPPromo = extraGPPromo;
                }
                this.calculateROI(isPlanFinal)
            }else{
                if(isPlanFinal){
                    this.extraGPPromoFinal = null;
                    this.valueROIFinal = null; 
                }else{
                    this.extraGPPromo = null;
                    this.valueROI = null; 
                }  
            }
    }

    calculateROI(isPlanFinal:boolean){
        let plan = isPlanFinal ? this.planFinal : this.planTarget;
        let extraGPPromo = isPlanFinal ? this.extraGPPromoFinal : this.extraGPPromo;
        if(this.isNotNullOrNaN(plan.costPPE) && plan.costPPE > 0 && this.isNotNullOrNaN(extraGPPromo)){
            let valueROI = Number(((extraGPPromo / plan.costPPE) * 100).toFixed(2));
            if(isPlanFinal){
                this.recalculateROI = true;
                this.valueROIFinal = valueROI;
                setTimeout(() => this.recalculateROI = false , 2000); 
                }else{
                    this.valueROI = valueROI;
                }
        }else{
            if(isPlanFinal){
                this.valueROI = null;
            }else{
                this.valueROI = null;   
            }
        }
    }

    onChangeExtraVolumePromo(isPlanFinal:boolean){
        this.calculateExtraGPPromo(isPlanFinal); 
    }

    onChangeExtraGPPromo(isPlanFinal:boolean){
      this.calculateROI(isPlanFinal);
    }

    onChangeGrossProfit(isPlanFinal:boolean){
        this.calculateExtraGPPromo(isPlanFinal);
    }

    onChangeTotalVolumeTons() {
        if(this.planFinal.incidenceKg != undefined && this.planFinal.incidenceKg.toString().trim() !== '' && this.planFinalEditable) {
            // General.confirm(
            //     i18n.t('PPE.CONFIRM_INCIDENCE_KG_CHANGE') as string,
            //     this,
            //     () => {
                    this.calculateIncidenceKg();
            //     }
            // );
        } else {
            this.calculateIncidenceKg();
        }
        this.calculateExtraVolumePromo(true);
    }

    calculateIncidenceKg() {
        if(this.isNotNullOrNaN(this.planFinal.costPPE) && this.isNotNullOrNaN(this.planFinal.totalVolumeTons)) {
            let result = 0;
            this.recalculateIncidence = true;
            if(this.planFinal.totalVolumeTons != 0) {              
                result = this.planFinal.costPPE / (this.planFinal.totalVolumeTons * 1000)
                this.planFinal.incidenceKg = Number(result.toFixed(3))
            } else {
                this.planFinal.incidenceKg = null;
            }
            setTimeout(() => this.recalculateIncidence = false , 2000); 
        }
    }

    onChangeTotalVolumeEuro() {
        if(this.planFinal.incidenceEuro != undefined && this.planFinal.incidenceEuro.toString().trim() !== '' && this.planFinalEditable) {
            // General.confirm(
            //     i18n.t('PPE.CONFIRM_INCIDENCE_EURO_CHANGE') as string,
            //     this,
            //     () => {
                    this.calculateIncidenceEuro();
            //     }
            // );
        } else {
            this.calculateIncidenceEuro();
        }
    }

    calculateIncidenceEuro() {
        if(this.isNotNullOrNaN(this.planFinal.costPPE) && this.isNotNullOrNaN(this.planFinal.totalVolumeEuroDurance)) {
            this.recalculateIncidence = true;
            if(this.planFinal.totalVolumeEuroDurance != 0) {
                let result = 0;
                result = (this.planFinal.costPPE / this.planFinal.totalVolumeEuroDurance) * 100
                this.planFinal.incidenceEuro = Number(result.toFixed(3))
            } else {
                this.planFinal.incidenceEuro = null;
            }
            setTimeout(() => this.recalculateIncidence = false , 2000); 
        }
    }

    onChangeCostPPE() {
        if(this.planFinalEditable) {
            // General.msgBoxAlert(i18n.t('PPE.ALERT_INCIDENCES_CHANGE') as string, this, () => {
                this.calculateIncidences();
                this.calculateExtraGPPromo(true);
            // });
        }
    }

    calculateIncidences() {
        this.calculateIncidenceKg();
        this.calculateIncidenceEuro();
    }

    isNotNullOrNaN(value: number) {
        return value != undefined && !Number.isNaN(value)
    }

    isSubsidiaryNotesEditable() {
        if(this.isAdminPpe || (this.planStatus == PPE_STATUS.IN_PROGRESS && this.planFinalEditable))  
            return true;
        else
            return false;
    }

    isHeadNotesEditable() {
        if(this.isAdminPpe || (this.planStatus == PPE_STATUS.EVALUATION_CHECK && this.planFinalEditable))
            return true;
        else
            return false;
    }

    checkPpeAdminClaim() {
        return General.CheckAuthorization(ClaimEnum.CanAdminPpe);
    }
}
